import axios from "axios";
import { toast } from "react-toastify";

export const fetchAllStates = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/state?${query_string}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneState = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/state/${id}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
}; 